import { has, get, find, map } from 'lodash';
import * as constants from '../../constants';
import { getUserDetails } from '../portalConfig';
import { getApiOwnerUser } from '../../utils';
import { getParsedApiDetails, getParsedCustomFields } from './responseParser';

const initialState = {
  isLoading: false,
  isError: false,
  selectedUsers: [],
  defaultSelectedUsers: [],
  availableUsers: [],
  errors: [],
  organizations: { results: [] },
  selectedOrganizations: [],
  allOrganizations: { results: [] },
  userContext: {},
  apiPermitted: { canEdit: true },
  allPortalTags: [],
  apiTags: [],
  newTags: [],
  swaggerData: {},
  apiDetails: { accessStatus: 'PRIVATE' },
  eulas: {},
  apiNameUnique: { d: { result: true } },
  assets: [],
  usage: {},
  customFields: [],
  policyTemplate: { managedGateways: [], policyTemplates: [] },
  proxyUrlUnique: { d: { result: true } },
  isApiSaveSuccess: false,
  selectedManageOrg: { name: '' },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.APP_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        isApiSaveSuccess: false,
        errors: [],
        isError: false,
      };
    case constants.API_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        isError: false,
        errors: [],
      };
    case constants.API_PERMISSION_AVAILABLE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        availableUsers: action.payload,
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_PERMISSION_SELECTED_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        defaultSelectedUsers: [...action.payload],
        selectedUsers: action.payload,
        isError: false,
        isApiSaveSuccess: false,
        errors: [],
      };
    case constants.API_PERMISSION_SAVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isApiSaveSuccess: true,
        apiDetails: getParsedApiDetails(action.payload),
        errors: [],
      };
    case constants.API_PERMISSION_ORGANIZATIONS_SUCCESS:
      {
        const orgs = state.organizations;
        const payload = action.payload;
        if (has(payload, 'results') && has(orgs, 'results')) {
          payload.results = [...orgs.results, ...action.payload.results];
        }
        return {
          ...state,
          isLoading: false,
          organizations: payload,
          isError: false,
          isApiSaveSuccess: false,
          errors: [],
        };
      }
    case constants.API_PERMISSION_ALL_ORGANIZATIONS_SUCCESS:
      {
        const payload = action.payload;
        return {
          ...state,
          isLoading: false,
          allOrganizations: payload,
          isError: false,
          isApiSaveSuccess: false,
          errors: [],
        };
      }
    case constants.API_PERMISSION_SELECTED_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedOrganizations: action.payload,
        isError: false,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_PERMISSION_SELECTED_MANAGE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedManageOrg: action.payload,
        isError: false,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        isApiSaveSuccess: false,
      };
    case constants.API_PERMISSION_SAVE_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        message: action.message,
        isApiSaveSuccess: true,
        errors: [],
        isError: false,
      };
    case constants.API_PERMISSION_REDIRECT_API_TAB:
      return {
        ...state,
        isApiVisibilitySaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_GET_SUCCESS:
      return {
        ...state,
        apiDetails: getParsedApiDetails(action.payload),
        errors: [],
        isApiSaveSuccess: false,
        isError: false,
      };
    case constants.API_PERMISSION_ACCESS_STATUS_SAVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isApiSaveSuccess: true,
        errors: [],
      };
    case constants.API_PERMISSION_PERMITTED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        apiPermitted: action.payload,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_PERMISSION_PERMITTED_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        apiPermitted: { canEdit: false },
        errors: action.payload,
        isApiSaveSuccess: false,
      };
    case constants.API_TAGS_ALL_TAGS_REQUEST:
      return {
        ...state,
        isLoading: false,
        isError: false,
        allPortalTags: [],
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_TAGS_ALL_TAGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        allPortalTags: action.payload.data,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_TAGS_API_TAGS_REQUEST:
      return {
        ...state,
        isLoading: false,
        isError: false,
        apiTags: [],
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_TAGS_API_TAGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        apiTags: action.payload.data,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_SWAGGER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        swaggerData: action.payload.data,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_TAGS_CREATE_TAGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        newTags: action.payload.data,
        errors: [],
        isApiSaveSuccess: false,
      };
    case constants.API_TAGS_ASSOCIATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        isApiSaveSuccess: false,
        errors: [],
      };
    case constants.API_TAGS_ASSOCIATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isApiSaveSuccess: true,
        errors: [],
      };
    case constants.API_USER_CONTEXTS:
      return {
        ...state,
        isLoading: false,
        userContext: action.payload,
      };
    case constants.API_EULAS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        eulas: action.payload,
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_NAME_UNIQUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        apiNameUnique: action.payload,
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_ASSETS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        assets: action.payload.map(({ name, type, uuid, links }) => ({
          name, uuid, links, ext: type && type.toLowerCase(),
        })),
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_USAGE_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        usage: action.payload,
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.CUSTOM_FIELDS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customFields: getParsedCustomFields(get(action, 'payload.d.results')),
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_CUSTOM_FIELDS_SAVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isApiSaveSuccess: true,
        isError: false,
        errors: [],
      };
    case constants.POLICY_TEMPLATES_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        policyTemplate: action.payload,
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_POLICY_TEMPLATES_SAVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isApiSaveSuccess: true,
        isError: false,
        errors: [],
      };
    case constants.API_PROXY_URL_UNIQUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        proxyUrlUnique: action.payload,
        isApiSaveSuccess: false,
        isError: false,
        errors: [],
      };
    case constants.API_SAVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        apiDetails: getParsedApiDetails(action.payload),
        isError: false,
        errors: [],
        isApiSaveSuccess: true,
      };
    case constants.API_PUBLISH_SAVE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        isApiSaveSuccess: true,
      };
    }
    case constants.API_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        isApiSaveSuccess: true,
      };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'permissions.isLoading');

export const getPermissionData = (state) => get(state, 'permissions.data');

export const getAvailableUsers = (state) => get(state, 'permissions.availableUsers');

export const getRedirectToDetailsPage = (state) => get(state, 'permissions.redirectToDetailsPage');

export const getOrganizations = (state) => get(state, 'permissions.organizations.results');

export const getAllOrganizations = (state) => get(state, 'permissions.allOrganizations.results');

export const getOrganizationsPage = (state) => get(state, 'permissions.organizations');

export const getSelectedOrganizations = (state) => get(state, 'permissions.selectedOrganizations');

export const getIsApiVisibilitySaveSuccess = state => get(state, 'permissions.isApiVisibilitySaveSuccess');

export const getUserContext = (state) => get(state, 'permissions.userContext');

export const getIsError = (state) => get(state, 'permissions.isError');

export const getErrors = state => get(state, 'permissions.errors');

export const getApiAccessStatus = (state) => get(state, 'permissions.apiDetails.accessStatus');

export const getApiPortalStatus = (state) => get(state, 'permissions.apiDetails.portalStatus');

export const getApiCanEditPermitted = (state) => get(state, 'permissions.apiPermitted.canEdit');

export const getApiDetails = (state) => get(state, 'permissions.apiDetails');

export const getAllPortalTags = (state) => get(state, 'permissions.allPortalTags');

export const getAPITags = (state) => get(state, 'permissions.apiTags');

export const getNewTags = (state) => get(state, 'permissions.newTags');

export const getAPISwaggerData = (state) => get(state, 'permissions.swaggerData');

export const getIsApiNameUnique = (state) => get(state, 'permissions.apiNameUnique.d.result');

export const getManagedGateways = (state) => get(state, 'permissions.policyTemplate.managedGateways');

export const getIsProxyUrlUnique = (state) => get(state, 'permissions.proxyUrlUnique.d.result');

export const getIsSaveApiSuccess = state => get(state, 'permissions.isApiSaveSuccess');

export const getIsApiTagAssocSaveSuccess = (state) => get(state, 'permissions.isApiTagAssocSaveSuccess');

export const getAssets = (state) => get(state, 'permissions.assets');

export const getUsage = (state) => get(state, 'permissions.usage');

export const getCustomFields = (state) => get(state, 'permissions.customFields');

export const getPolicyTemplates = (state) => get(state, 'permissions.policyTemplate.policyTemplates');

export const getIsApiManagementSaveSuccess = (state) => get(state, 'permissions.isApiManagementSaveSuccess');

export const getPublisherOrganizations = (state) =>
  get(state, 'permissions.organizations.results', []).filter(org => org.type === 'PUBLISHER');

export const getSelectedManageOrg = (state) => get(state, 'permissions.selectedManageOrg');

export const getSelectedUsers = (state) => {
  const userDetails = getUserDetails(state);
  const selectedUsers = get(state, 'permissions.selectedUsers');
  if (userDetails && userDetails.apiOwner) {
    const isApiOwner = find(selectedUsers, { uuid: userDetails.uuid });
    // Add the apiowner by default when logged in user as apiOwner
    if (!isApiOwner) {
      selectedUsers.push(getApiOwnerUser(userDetails));
    }
  }
  return selectedUsers;
};

export const getDefaultSelectedUsers = (state) => get(state, 'permissions.defaultSelectedUsers');

export const getEulas = (state) => {
  const results = get(state, 'permissions.eulas.d.results') || [];
  return map(results, obj => ({ uuid: obj.Uuid, name: obj.Name }));
};



// WEBPACK FOOTER //
// ./src/reducers/api/index.js